import { createColumnHelper } from '@tanstack/react-table';

import { ServiceRowData } from '../types';

export const columnHelper = createColumnHelper<ServiceRowData>();
